import styled from '@emotion/styled';
import styleService from '@nykaa/deals-utils/styles';
const { setVisibility, getMarginStyles, getPaddingStyles, getFontStyles, addAlpha, } = styleService.utils;
// eslint-disable-next-line import/prefer-default-export
export const Button = styled.button `
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  ${({ visible }) => setVisibility(visible)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ margin }) => getMarginStyles(margin)};
  ${({ buttonText }) => getFontStyles(buttonText)};
  background: ${({ bkg }) => addAlpha(bkg === null || bkg === void 0 ? void 0 : bkg.color, bkg.alpha)} !important;
  margin-bottom: -${({ padding }) => { var _a; return (_a = padding === null || padding === void 0 ? void 0 : padding.top) === null || _a === void 0 ? void 0 : _a.web; }};
  z-index: 1;
`;
// margin-bottom: calc(${({widgetSpacing}: ButtonStyleProps) =>  });
